<template>
  <div class="login-container">
    <div class="login-shell">
      <el-card class="login-card">
        <div slot="header" class="login-header">
          <h2>{{ dspTitle }} - 登录</h2>
        </div>
        <el-form :model="loginForm" :rules="loginRules" ref="loginForm" @submit.native.prevent="handleLogin">
          <el-form-item prop="username">
            <el-input
              v-model="loginForm.username"
              placeholder="用户名"
              prefix-icon="el-icon-user"
              clearable>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              type="password"
              v-model="loginForm.password"
              placeholder="密码"
              prefix-icon="el-icon-lock"
              show-password
              @keyup.enter.native="handleLogin">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="loading"
              @click="handleLogin"
              style="width: 100%;">
              {{ loading ? '登录中...' : '登 录' }}
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <div v-if="icpLicenseNo" class="login-icp">
        {{ icpLicenseNo }}
      </div>
    </div>
  </div>
</template>

<script>
import { loginRequest } from '@/api/auth';

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
      },
      loginRules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      loading: false,
    };
  },
  computed: {
    dspTitle() {
      return this.$dspTitle || '艾克斯广告平台'
    },
    icpLicenseNo() {
      return this.$icpLicenseNo || ''
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          try {
            const response = await loginRequest(this.loginForm.username, this.loginForm.password);
            if (response && response.code === 0) {
              // 登录成功
              localStorage.setItem('isAuthenticated', 'true'); // 设置登录状态
              localStorage.setItem('accountName', this.loginForm.username);
              this.$message.success('登录成功');
              // 跳转到仪表盘或之前的目标页面
              const redirect = this.$route.query.redirect || '/dashboard';
              this.$router.push(redirect);
            } else {
              // 登录失败
              this.$message.error(response.message || '登录失败，请检查用户名和密码');
            }
          } catch (error) {
            // 请求本身出错（已在api/auth.js处理，这里理论上不会执行，除非promise被reject）
             this.$message.error('登录请求失败，请稍后重试');
             console.error("Login request error:", error);
          } finally {
            this.loading = false;
          }
        } else {
          console.log('表单验证失败');
          return false;
        }
      });
    },
  },
   created() {
    // 如果 Vuex 中还没有 dspTitle，可以尝试从 API 获取
    if (!this.dspTitle) {
      this.$store.dispatch('fetchDspConfig'); // 假设已有此 action
    }
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  padding: 24px;
  box-sizing: border-box;
  background-color: #f5f7fa;
}

.login-shell {
  width: 100%;
  max-width: 400px;
}

.login-card {
  width: 100%;
}

.login-header {
  text-align: center;
}

.login-header h2 {
  margin: 0;
  font-weight: normal;
  color: #303133;
}

.login-icp {
  margin-top: 18px;
  text-align: center;
  font-size: 12px;
  line-height: 1.6;
  color: #8c96a8;
}
</style>
